import "./style/main.css";
import "./style/fast.css";
import "./style/index.css";
import "./style/font-awesome.min.css";
import AppRoute from "./routes/AppRoute";

function App() {
  return (
    <div style={{ height: "100%" }}>
      <AppRoute />
    </div>
  );
}
export default App;
